import { createComponent, createHook } from "reakit-system";
import { css, cx } from "@emotion/css";
import type { TextHTMLProps, TextOptions } from "../Text/Text";
import { useText } from "../Text/Text";

export type HintTextOptions = Omit<TextOptions, "lineHeight" | "fontSize" | "color" | "fontWeight">;
export type HintTextProps = HintTextOptions & TextHTMLProps;

export const useHintText = createHook<HintTextOptions, TextHTMLProps>({
  compose: [useText],
  useOptions(options) {
    return {
      ...options,
      color: "hintColor",
      fontSize: "hintFontSize",
      lineHeight: "hintLineHeight",
      fontWeight: "normal",
    };
  },
  useProps(_, { className, ...props }) {
    return {
      ...props,
      className: cx(className, css({ label: "Hint" })),
    };
  },
});

export const HintText = createComponent<"span", HintTextOptions>({
  as: "span",
  useHook: useHintText,
  memo: true,
});
